import { SchemaDefinition } from "../validator/schema-definition-interface";

/**
 * The schema definition for the stored accessory service object.
 */
export const storedAccessoryServiceSchema: SchemaDefinition = {
	Name: 'stored-accessory-service',
	Properties: {
		ServiceName: { Type: 'string' },
		Quantity: { Type: 'number' }
	}
}